import { render, staticRenderFns } from "./AddOriginalInvoice.vue?vue&type=template&id=0317ac5e"
import script from "./AddOriginalInvoice.vue?vue&type=script&lang=js"
export * from "./AddOriginalInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports